import React, { useState } from "react";
import { useSelector } from "react-redux";

import Logo from "../assets/images/logo.png";
import Facebook from "../assets/images/icons/social/facebook.svg";
import Instagram from "../assets/images/icons/social/Instagram.svg";
import Whatsapp from "../assets/images/icons/social/Whatsapp.svg";
import Telegram from "../assets/images/icons/social/Telegram.svg";
import Twitter from "../assets/images/icons/social/Twitter.svg";
import BTC from "../assets/images/icons/pay-partners/btc.svg";
import Usdt from "../assets/images/icons/pay-partners/usdt.svg";
import Ethereum from "../assets/images/icons/pay-partners/ethereum.svg";
import PhonePe from "../assets/images/icons/pay-partners/phonepe.svg";
import GPay from "../assets/images/icons/pay-partners/gpay.svg";
import PayTM from "../assets/images/icons/pay-partners/paytm.svg";
import UPI from "../assets/images/icons/pay-partners/upi.svg";
import Age18Plus from "../assets/images/icons/age18-plus.webp";
import LicenseValidation from "../assets/images/license.png";
import SecureImg from "../assets/images/secure.jpg";
import AndroidIcon from "../assets/images/icons/android-icon.svg";
import ChevronRight from "../assets/images/icons/chevron-right.svg";
import BottomNav from "./BottomNav";

import Ezugi from "../assets/images/provider/ezugi.webp";
import Evolution from "../assets/images/provider/evolution.webp";
import Supernowa from "../assets/images/provider/supernowa.webp";
import XPG from "../assets/images/provider/xpg.webp";
import Vivo from "../assets/images/provider/vivogaming.webp";
import Slots from "../assets/images/provider/powergames.webp";
import Spribe from "../assets/images/provider/spribe.webp";
import WorldCasino from "../assets/images/provider/worldcasino.webp";
import Qtech from "../assets/images/provider/qtech.webp";
import Netent from "../assets/images/provider/netent.webp";
import Jili from "../assets/images/provider/playngo.webp";
import mac88 from "../assets/images/provider/mac88.webp";
import Kingmaker from "../assets/images/provider/kingmaker.webp";
import RedTiger from "../assets/images/provider/redtiger.webp";
import Turbogames from "../assets/images/provider/turbogames.webp";
import AESexy from "../assets/images/provider/aesexy.webp";
import SmartSoftGaming from "../assets/images/provider/SmartSoft.webp";
import RelaxGaming from "../assets/images/provider/RelexGaming.webp";
import Auragaming from "../assets/images/provider/auragaming.webp";
import playngo from "../assets/images/provider/playngo.webp";
import Habenero from "../assets/images/provider/habanero.webp";
import dragoonsoft from "../assets/images/provider/dragoonsoft.webp";
import hacksaw from "../assets/images/provider/hacksaw.webp";

import Rating from "../assets/images/icons/rating1.png";

import BankDeposit from "../assets/images/payments/BankDeposit.png";
import Gpay from "../assets/images/payments/Gpay.png";
import Hdfc from "../assets/images/payments/HDFC.png";
import Icici from "../assets/images/payments/ICICI.png";
import Kotak from "../assets/images/payments/Kotak.png";
import MasterCard from "../assets/images/payments/MasterCard.png";
import Neteller from "../assets/images/payments/Neteller.png";
import Phonepe from "../assets/images/payments/Phonepe.png";
import Sbi from "../assets/images/payments/SBI.png";
import Skrill from "../assets/images/payments/Skrill.png";
import Upi from "../assets/images/payments/UPI.png";
import Visa from "../assets/images/payments/Visa.png";
import Worldpay from "../assets/images/payments/WorldPay.png";

import { useTranslation } from "react-i18next";

const BeforeLoginFooter = () => {
  const { appDetails } = useSelector((state) => state.app);
  const { t } = useTranslation();
  return (
    <>
      <footer className="footer">
        <div className="GameProviderSection">
          {/* <div className="GamesProvider">
            <h3>Game Providers</h3>
            <ul>
              <li>
                <a href="/casino/ezugi">
                  <img src={Ezugi} alt="" />
                </a>
              </li>
              <li>
                <a href="/casino/evolution">
                  <img src={Evolution} alt="" />
                </a>
              </li>
              <li>
                <a href="/casino/supernowa">
                  <img src={Supernowa} alt="" />
                </a>
              </li>
              <li>
                <a href="/casino/xpg">
                  <img src={XPG} alt="" />
                </a>
              </li>
              <li>
                <a href="/casino/vivo">
                  <img src={Vivo} alt="" />
                </a>
              </li>
              <li>
                <a href="/qtechgames">
                  <img src={Spribe} alt="" />
                </a>
              </li>
              <li>
                <a href="/casino/worldcasino">
                  <img src={WorldCasino} alt="" />
                </a>
              </li>
              <li>
                <a href="/casino/qtech">
                  <img src={Qtech} alt="" />
                </a>
              </li>
              <li>
                <a href="/casinogames">
                  <img src={Netent} alt="" />
                </a>
              </li>
              <li>
                <a href="/casinogames">
                  <img src={Kingmaker} alt="" />
                </a>
              </li>

              <li>
                <a href="/casinogames">
                  <img src={RedTiger} alt="" />
                </a>
              </li>
              <li>
                <a href="/gap">
                  <img src={Jili} alt="" />
                </a>
              </li>
              <li>
                <a href="/gap">
                  <img src={mac88} alt="" />
                </a>
              </li>
              <li>
                <a href="/gap">
                  <img src={Turbogames} alt="" />
                </a>
              </li>
              <li>
                <a href="/asino/aesexy">
                  <img src={AESexy} alt="" />
                </a>
              </li>
              <li>
                <a href="/gap">
                  <img src={SmartSoftGaming} alt="" />
                </a>
              </li>
              <li>
                <a href="/gap">
                  <img src={RelaxGaming} alt="" />
                </a>
              </li>
              <li>
                <a href="/gap">
                  <img src={Auragaming} alt="" />
                </a>
              </li>
              <li>
                <a href="/gap">
                  <img src={playngo} alt="" />
                </a>
              </li>
              <li>
                <a href="/gap">
                  <img src={Habenero} alt="" />
                </a>
              </li>
              <li>
                <a href="/gap">
                  <img src={dragoonsoft} alt="" />
                </a>
              </li>
              <li>
                <a href="/gap">
                  <img src={hacksaw} alt="" />
                </a>
              </li>
            </ul>
          </div> */}

          <div className="PaymentSection">
            <h3>Payments Methods</h3>
            <ul>
              <li>
                <img src={BankDeposit} alt="" />
              </li>
              <li>
                <img src={Gpay} alt="" />
              </li>
              <li>
                <img src={Hdfc} alt="" />
              </li>
              <li>
                <img src={Icici} alt="" />
              </li>
              <li>
                <img src={Kotak} alt="" />
              </li>

              <li>
                <img src={Phonepe} alt="" />
              </li>
              <li>
                <img src={Sbi} alt="" />
              </li>

              <li>
                <img src={Upi} alt="" />
              </li>

              <li>
                <img src={Worldpay} alt="" />
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-links">
          <ul>
            <h5>{t("menu")}</h5>
            <li>
              <a href="/">{t("home")}</a>
            </li>
            <li>
              <a href="/casinogames">{t("casino")}</a>
            </li>
            <li>
              <a href="/livecasino">{t("live_casino")}</a>
            </li>
            <li>
              <a href="/atlas-lobby">{t("sports")}</a>
            </li>
            <li>
              <a href="/sports/Inplay">{t("exchange")}</a>
            </li>
            <li>
              <a href="/casino/spribe/aviator">{t("aviator")}</a>
            </li>
          </ul>
          <ul>
            <h5>{t("sitemap")}</h5>
            <li>
              <a href="/responsiblegame">{t("responsible_gaming")}</a>
            </li>
            <li>
              <a href="/terms">{t("terms_and_conditions")}</a>
            </li>

            <li>
              <a href="/fairplay">{t("fair_play")}</a>
            </li>
            <li>
              <a href="/gamesrule">{t("games_rules")}</a>
            </li>
          </ul>
          <ul>
            <h5>Privacy and Policy</h5>
            <li>
              <a href="/privacypolicys">{t("privacy_policy")}</a>
            </li>

            <li>
              <a href="/aml_kyc_policys">{t("AML_KYC_policy")}</a>
            </li>
          </ul>
          <ul>
            <h5>{t("support")}</h5>
            <li>
              <a href="/contactuss">{t("contact_us")}</a>
            </li>
            {/* <li>  
              <a
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "#"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  {t("support")} <span>+91 7520639447</span>
              </a> 
            </li> */}
          </ul>
        </div>

        <div className="social-wallet">
          <div className="logo">
            <a href="/homr">
              <img src={appDetails?.LOGO_URL} alt="Logo" height={60} />
              {/* <img src={Logo} alt="Logo" /> */}
            </a>

            {/* <p>{appDetails?.FOOTER_TEXT || ""}</p> */}
          </div>
          <div className="license-apk">
            {/* <a href="javascript:void(0)" className="license">
              <img src={LicenseValidation} alt="license validation" />
            </a> */}

            <div className="secure">
              <img src={SecureImg} alt="safe and secure" />
            </div>

            <a
              href="https://dl.dropbox.com/scl/fi/na1uuzsklaju1o1ighzpm/Worldwin.apk?rlkey=pqnu6gb6wynqmx3ermgkibpdt&st=2d99vz0c&dl=0"
              download="https://dl.dropbox.com/scl/fi/na1uuzsklaju1o1ighzpm/Worldwin.apk?rlkey=pqnu6gb6wynqmx3ermgkibpdt&st=2d99vz0c&dl=0"
              className="download-apk ms-0"
            >
              <img src={AndroidIcon} alt="android apk" />
              <div className="text">
                <span>{t("application")}</span>
                <strong>{t("for_android")}</strong>
              </div>
              <img
                src={ChevronRight}
                alt="chevron right"
                className="arrow ms-auto d-lg-none"
              />
            </a>
          </div>
          <div className="follow-us">
            <h5>{t("follow_us")}</h5>
            <ul>
              <li>
                <a
                  href={appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"}
                  target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                >
                  <img src={Facebook} alt="facebook" />
                </a>
              </li>
              <li>
                <a
                  href={
                    appDetails?.INSTATGRAM != "" ? appDetails?.INSTATGRAM : "#"
                  }
                  target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                >
                  <img src={Instagram} alt="instagram" />
                </a>
              </li>
              <li>
                <a href="" target="_blank">
                  <img src={Twitter} alt="twitter" />
                </a>
              </li>
              <li>
                <a
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "#"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <img src={Whatsapp} alt="whatsapp" />
                </a>
              </li>
              <li>
                <a
                  href={appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"}
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <img src={Telegram} alt="telegram" />
                </a>
              </li>
            </ul>
          </div>
          <div className="sup-wallet">
            <h5>Supported Wallet</h5>
            <ul>
              <li>
                <img src={BTC} alt="ttc" />
              </li>
              <li>
                <img src={Ethereum} alt="ethereum" />
              </li>
              <li>
                <img src={Usdt} alt="usdt" />
              </li>
            </ul>
          </div>
        </div>

        <div className="copy-age">
          <div className="age18">
            <p>{t("age18_content")}</p>
            <img src={Age18Plus} alt="age 18 plus" />
          </div>

          <div className="copyright">
            <p>{t("copyright")}</p>
          </div>
        </div>
      </footer>

      <BottomNav />
    </>
  );
};

export default BeforeLoginFooter;
